import { render, staticRenderFns } from "./StudentOrder.vue?vue&type=template&id=1e3cd201&scoped=true&"
import script from "./StudentOrder.vue?vue&type=script&lang=js&"
export * from "./StudentOrder.vue?vue&type=script&lang=js&"
import style0 from "./StudentOrder.vue?vue&type=style&index=0&id=1e3cd201&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3cd201",
  null
  
)

export default component.exports